import { useEffect, useState } from "react";
import api from "../api";

export default function LeadCapture() {
  const [code, setCode] = useState("");
  const [form, setForm] = useState(null);
  const [status, setStatus] = useState("loading");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState("+593");
  const [error, setError] = useState("");

  useEffect(() => {
    const parts = window.location.pathname.split("/");
    const c = parts[parts.length - 1] || "";
    setCode(c);
    (async () => {
      try {
        const { data } = await api.get(`lead-forms/public/${c}/`);
        setForm(data);
        setStatus("ready");
      } catch (e) {
        setStatus("error");
      }
    })();
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      let p = String(phone || "").trim().replace(/\s+/g, "").replace(/-/g, "");
      if (p.startsWith("0")) p = p.replace(/^0+/, "");
      if (!p.startsWith("+")) {
        const cc = String(countryCode || "").trim();
        p = `${cc}${p}`;
      }
      await api.post(`lead-capture/${code}/`, {
        first_name: firstName,
        last_name: lastName,
        phone: p,
      });
      setStatus("sent");
    } catch (e) {
      setError(e?.response?.data?.detail || e?.message || "No se pudo enviar");
    }
  };

  if (status === "loading")
    return (
      <div style={styles.loadingBox}>
        <div style={styles.loader}></div>
        <p style={{ color: "#64748b", marginTop: 12 }}>Cargando formulario…</p>
      </div>
    );

  if (status === "error")
    return (
      <div style={styles.messageBox}>
        <h2>Formulario no encontrado</h2>
        <p>Verifica el enlace o comunícate con soporte.</p>
      </div>
    );

  if (status === "sent")
  return (
    <div style={styles.container}>
      <div style={styles.sentCard}>
        <div style={styles.iconSuccess}>✓</div>
        <h2 style={styles.sentTitle}>¡Gracias!</h2>
        <p style={styles.sentText}>
          Tus datos fueron registrados correctamente.
        </p>
      </div>
    </div>
  );


  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>{form?.message_title || "Formulario"}</h2>

        {form?.message_content ? (
          <div
            dangerouslySetInnerHTML={{ __html: form.message_content }}
            style={styles.infoBox}
          />
        ) : null}

        {error ? <div style={styles.error}>{error}</div> : null}

        <form onSubmit={submit} style={styles.form}>
          <div>
            <label style={styles.label}>Nombre</label>
            <input
              style={styles.input}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
              placeholder="Ingresa tu nombre"
            />
          </div>

          <div>
            <label style={styles.label}>Apellido</label>
            <input
              style={styles.input}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
              placeholder="Ingresa tu apellido"
            />
          </div>

          <div>
            <label style={styles.label}>Teléfono</label>
            <div style={styles.phoneRow}>
              <select
                style={styles.select}
                value={countryCode}
                onChange={(e) => setCountryCode(e.target.value)}
              >
                <option value="+51">+51 (PE)</option>
                <option value="+52">+52 (MX)</option>
                <option value="+57">+57 (CO)</option>
                <option value="+54">+54 (AR)</option>
                <option value="+56">+56 (CL)</option>
                <option value="+593">+593 (EC)</option>
                <option value="+58">+58 (VE)</option>
                <option value="+505">+505 (NI)</option>
                <option value="+506">+506 (CR)</option>
                <option value="+507">+507 (PA)</option>
                <option value="+34">+34 (ES)</option>
              </select>
              <input
                style={{ ...styles.input, flex: 1 }}
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
                placeholder="Número sin código de país"
              />
            </div>
            <small style={styles.helper}>
              Si comienzas con 0, lo quitaremos automáticamente.
            </small>
          </div>

          <button type="submit" style={styles.button}>
            Enviar
          </button>
        </form>
      </div>
    </div>
  );
}

// 🎨 Estilos modernos
const styles = {
  container: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f9fafb, #f1f5f9)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    fontFamily:
      "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  },
  card: {
    background: "#fff",
    borderRadius: 16,
    boxShadow:
      "0 4px 20px rgba(0,0,0,0.05), 0 2px 8px rgba(0,0,0,0.03)",
    padding: 32,
    width: "100%",
    maxWidth: 500,
    animation: "fadeIn 0.4s ease",
  },
  title: {
    marginBottom: 12,
    fontSize: 22,
    fontWeight: 700,
    color: "#1e293b",
    textAlign: "center",
  },
  infoBox: {
    background: "#f8fafc",
    padding: 12,
    borderRadius: 8,
    color: "#475569",
    fontSize: 15,
    marginBottom: 16,
  },
  form: {
    display: "grid",
    gap: 16,
  },
  label: {
    display: "block",
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 6,
    color: "#334155",
  },
  input: {
    width: "100%",
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid #cbd5e1",
    outline: "none",
    fontSize: 15,
    transition: "all 0.2s ease",
    color: "#0f172a", // 👈 texto visible
    background: "#fff",
  },
  select: {
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid #cbd5e1",
    outline: "none",
    fontSize: 15,
    background: "#fff",
    color: "#0f172a", // 👈 texto visible
  },
  phoneRow: {
    display: "flex",
    gap: 8,
    alignItems: "center",
  },
  helper: {
    color: "#64748b",
    fontSize: 13,
    marginTop: 4,
    display: "block",
  },
  button: {
    background: "#14b8a6",
    color: "#fff",
    border: "none",
    padding: "12px 20px",
    borderRadius: 10,
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer",
    transition: "background 0.2s ease, transform 0.2s ease",
  },
  error: {
    color: "#dc2626",
    background: "#fee2e2",
    padding: "8px 12px",
    borderRadius: 8,
    marginBottom: 12,
  },
  messageBox: {
    textAlign: "center",
    padding: 40,
    fontFamily: "system-ui, sans-serif",
    color: "#334155",
  },
  loadingBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    background: "#f8fafc",
  },
  loader: {
    width: 36,
    height: 36,
    border: "4px solid #e2e8f0",
    borderTopColor: "#14b8a6",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
  sentCard: {
  background: "#fff",
  borderRadius: 16,
  boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
  padding: "40px 32px",
  maxWidth: 420,
  width: "100%",
  textAlign: "center",
  animation: "fadeIn 0.4s ease",
},
iconSuccess: {
  width: 60,
  height: 60,
  borderRadius: "50%",
  background: "#d1fae5",
  color: "#059669",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 32,
  fontWeight: "bold",
  margin: "0 auto 16px auto",
},
sentTitle: {
  color: "#065f46",
  fontSize: 24,
  fontWeight: 700,
  marginBottom: 8,
},
sentText: {
  color: "#334155",
  fontSize: 16,
},

};

// Animación
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(
  `@keyframes spin { to { transform: rotate(360deg); } }`,
  styleSheet.cssRules.length
);
styleSheet.insertRule(
  `@keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }`,
  styleSheet.cssRules.length
);
